import React from 'react';
import { TabPanel } from '@one-thd/sui-atomic-components';
import { number, string, bool } from 'prop-types';
import { quotesPropType } from '../../utils/propTypes';
import QuotesCompactList from './QuotesCompactList';
import QuotesCarousel from './QuotesCarousel';

const QuotesTabPanels = ({
  activeQuotes, expiredQuotes, maxListSize, componentId, isMobile
}) => {
  return (
    <div className="sui-pt-3 @sm:sui-pt-4 sui-h-full">
      <TabPanel value="active" index={0}>
        {isMobile ? (
          <div>
            <QuotesCompactList quotes={activeQuotes} maxListSize={maxListSize} componentId={componentId} />
          </div>
        ) : (
          <div>
            <QuotesCarousel quotes={activeQuotes} componentId={componentId} />
          </div>
        )}
      </TabPanel>
      <TabPanel value="expired" index={1}>
        {isMobile ? (
          <div>
            <QuotesCompactList quotes={expiredQuotes} maxListSize={maxListSize} componentId={componentId} />
          </div>
        ) : (
          <div>
            <QuotesCarousel quotes={expiredQuotes} componentId={componentId} />
          </div>
        )}
      </TabPanel>
    </div>
  );
};

QuotesTabPanels.propTypes = {
  activeQuotes: quotesPropType,
  expiredQuotes: quotesPropType,
  maxListSize: number,
  componentId: string,
  isMobile: bool
};

QuotesTabPanels.defaultProps = {
  activeQuotes: [],
  expiredQuotes: [],
  maxListSize: 3,
  componentId: '',
  isMobile: false
};

export default QuotesTabPanels;
